import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex } from '@chatterbug/aaron'

import Pressable from 'src/ui/Pressable/Pressable'
import AspectRatioImage from 'src/ui/AspectRatioImage/AspectRatioImage'

import CardInfo from './subcomponents/CardInfo'

const Card = ({
  imgUrl,
  title,
  subtitle,
  description,
  onClick,
  aspectRatio,
  label,
  footer,
  linkUrl,
  ...rest
}) => {
  return (
    <Flex
      boxShadow="raised"
      flexDirection="column"
      onClick={onClick}
      width="100%"
      borderRadius="1x"
      backgroundColor="white100"
      {...rest}
    >
      <Pressable
        linkUrl={linkUrl}
        display="flex"
        flexDirection="column"
        flex="1"
      >
        {imgUrl && (
          <AspectRatioImage
            imgUrl={imgUrl}
            aspectRatio={aspectRatio}
            borderRadius="1x"
            margin="0,5x"
            marginBottom="0"
          />
        )}
        <Box m="2x" flex="1">
          <CardInfo
            title={title}
            subtitle={subtitle}
            description={description}
            label={label}
          />
          {/* Optional Footer, e.g. for rating stars or writing button */}
          {footer && (
            <Flex mt="2x" alignItems="flex-end" flex="1">
              {footer}
            </Flex>
          )}
        </Box>
      </Pressable>
    </Flex>
  )
}
Card.propTypes = {
  imgUrl: PropTypes.string,
  title: PropTypes.any,
  subtitle: PropTypes.any,
  description: PropTypes.string,
  onClick: PropTypes.func,
  aspectRatio: PropTypes.string,
  label: PropTypes.any,
  footer: PropTypes.any,
  linkUrl: PropTypes.string.isRequired,
}
export default Card
